import { React, useContext, useEffect, useState, } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import IndustryFilter from "../../Components/RefineSearchComponents/IndustryFilter";
import SectorFilter from "../../Components/RefineSearchComponents/PESectorFilter";
import YearFoundedFilter from "../../Components/RefineSearchComponents/YearFoundedFilter";
import CountryFilter from "../../Components/RefineSearchComponents/CountryFilter";
import RegionFilter from "../../Components/RefineSearchComponents/RegionFilter";
import StateFilter from "../../Components/RefineSearchComponents/StateFilter";
import ExcludeDefunctFilter from "../RefineSearchComponents/ExcludeDefunctFilter";
import FirmTypeFilter from "../RefineSearchComponents/FirmTypeFilter";
import VcFundedFilter from "../RefineSearchComponents/VcFundedFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import IncubationStatusFilter from '../RefineSearchComponents/IncubationStatusFilter'
import { useLocation,  useNavigate } from "react-router";
import { filterLocationUrl, filterSectorByIndutry, tagList } from "../../Config/config";
import axios from "axios";
import { UserContext } from "../../Contexts/UserContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import DefinitionModal from "../TagDefinitionModal";
import { Tooltip } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Investor from "../RefineSearchComponents/Investor";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import CityFilter from "../RefineSearchComponents/CityFilter";
/**
 * The function `IncubationRefineSearch` is a React component that renders a form for refining search
 * filters in an incubation context.
 * @returns The function `IncubationRefineSearch` returns JSX elements.
 */
function IncubationRefineSearch({ customPathname, generalPathname }) {
    const {
        setSectors,Sectors,lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions ,dbDropdown , setDbDropdown ,checkToggleBtn,setToggleDealsBtn,
        onErrorHandler,SwitchState,setSwitchState,dropdown,
        incubatorOptions , setIncubatorOptions ,TargetCompanyOptions , setTargetCompanyOptions ,AllCities,
        setrefineSearchFilters,
        refineSearchFilters ,setMonthPickerValue, getSectorByIndustry, accessControl } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(32);
    const navigate = useNavigate();
    // const isMatch = useMatch({ path: routeNames.pe_companies_incubation })
    const { getToken } = useContext(UserContext);
    const location = useLocation();
    const {pathname} = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false


    //local updated options
    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [EndYearOptions, setEndYearOptions] = useState([]);
    const [StartYearOptions, setStartYearOptions] = useState([])
    const [CountryOptions, setCountryOptions] = useState([])
    const [RegionOptions, setRegionOptions] = useState([])
    const [StateOptions, setStateOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [TagSwitchState, setTagSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])
    const [FirmTypeOptions, setFirmTypeOptions] = useState([])
    const [VCFundedOptions, setVCFundedOptions] = useState([])
    const [IncubationStatusOptions, setIncubationStatusOptions] = useState([])
    const [isExclude, setisExclude] = useState(false)
    
    // Centralized popup state management - only one filter popup can be open at a time
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    useEffect(() => {
        const ids = IndustriesOptions?.length > 0 ? 
            IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];

        if (ids?.length > 0) {
            getSectorByIndustry(ids, "investments")
        } else {
            setSectors([])
        }

    }, [IndustriesOptions])

    useEffect(() => {
        if(accessControl?.peindustries?.id?.length > 0){
            const ids = accessControl ? accessControl?.peindustries?.id : []
            getSectorByIndustry(ids, "investments")
        }
    }, [])


  /**
   * The `applyFilter` function updates the refine search filters based on the selected options.
   */
    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = SectorOptions.filter(option => option.isChecked);
        const selectedStartYear = StartYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedEndYear = EndYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedCountries = CountryOptions?.filter(option => option.isChecked);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedState = StateOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedFirm = FirmTypeOptions?.filter(option => option.isChecked);
        const selectedVc = VCFundedOptions?.filter(option => option.isChecked);
        const selectedStatus = IncubationStatusOptions?.filter(option => option.isChecked);
        const selectedOperators = SwitchState;
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedInvestor = incubatorOptions?.filter(option => option.isChecked); 
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                industry: selectedIndustries,
                sector: selectedSectors,
                yearFounded: selectedEndYear != null && selectedStartYear != null ? [selectedStartYear, selectedEndYear] : [],
                countries: selectedCountries,
                region: selectedRegion,
                state: selectedState,
                city: selectedCity,
                operator: TagSwitchState ? 1 : 0,
                tags: TagsOptions,
                target_company:selectedTargetCompany,
            },
            [customPathname]: {
                ...prev[customPathname],
                firmType: selectedFirm,
                deals_operator : selectedOperators,
                investor_id : selectedInvestor ,
                vcFunded: selectedVc,
                incubationStatus: selectedStatus,
                excludeDefunctCos: isExclude ? [{ id: 1, name: "Exclude Defunct Cos", value: isExclude }] : [],
            },
        }))
        checkToggleBtn();
    }

  /**
   * The function `resetFilter` resets a specific filter in the `refineSearchFilters` object by setting
   * its value to an empty object.
   */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {},
            [customPathname]: {}
        }))
        setTargetCompanyOptions([]);
        setIncubatorOptions([]);
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setSectors([]);
        setToggleDealsBtn(true);
    }
    useEffect(()=>{
        setToggleDealsBtn(true);
    },[customPathname])



    // Submitting Refine Search Form 
  /**
   * The function `refineSearchFilter` updates search filters, resets the month picker value, sets the
   * current page to 1, applies the filter, navigates to a custom pathname if necessary, and sets the
   * selected state to false.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. It can contain information about the event, such as the target element, the type of
   * event, and any additional data associated with the event. In this case, it is used to prevent the
   * default behavior of a form submission,
   */
    const refineSearchFilter = (event) => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
            },
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null) {
        //     navigate(routeNames.pe_companies_incubation);
        // }
        applyFilter();
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
        setSelected(false)

    }

    useEffect(() => {
        setrefineSearchFilters((prev) => ({
            ...prev,
            [generalPathname]: {
                ...prev[generalPathname],
                firmType:[],
                firm_Sub_type:[],
                investor_id: [],
                ladvisors: [],
                tadvisors: []
            }
        }))
    }, [])


  /**
   * The function `onResetClick` resets the current page, filters, and navigates to a custom pathname
   * if it is different from the current location.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. In this case, it is the click event that occurred when the user clicked on a reset
   * button.
   */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null) {
        //     navigate(routeNames.pe_companies_incubation);
        // }
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

  /**
   * The function `accordionClick` sets the selected value to 0 if it is equal to `select`, otherwise
   * it sets it to the provided value.
   * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It is
   * used to determine whether the accordion should be selected or deselected.
   */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

  /**
   * The `onCountryChange` function takes in a list of options, filters them based on whether they are
   * checked, and then makes a POST request to a specified URL with the filtered options as parameters.
   * @param options - The `options` parameter is an array of objects. Each object represents an
   * industry and has the following properties:
   */
    const onCountryChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: ids,
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setRegionOptions(response.data?.region)
                setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

  /**
   * The function `onRegionChange` takes in an array of options, filters the options based on a
   * condition, maps the filtered options to extract specific properties, and then makes a POST request
   * using axios to a specified URL with the extracted properties as parameters.
   * @param options - The `options` parameter is an array of objects. Each object represents an
   * industry and has the following properties:
   */
    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    /**
   * The `onStateChange` function sends a POST request to a specified URL with selected country,
   * region, and state options, and updates the city options based on the response.
   * @param options - The `options` parameter is an array of objects that represent industries. Each
   * object has the following properties:
   */
    const onStateChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: selectedRegion,
            state: ids,
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    useEffect(() => {
        const countryIds = refineSearchFilters[customPathname]?.countries?.map(value => value.id) ?? [];
        const ids = refineSearchFilters[customPathname]?.region?.map(value => value.id) ?? [];
        const stateIds = refineSearchFilters[customPathname]?.state?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[customPathname]?.city?.map(value => value.id) ?? [];
        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status == 200) {
                setCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: countryIds.includes(option.id) })))
                setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
                setStateOptions(response.data.state?.map(option => ({ ...option, isChecked: stateIds.includes(option.id) })))
                setCityOptions(AllCities?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters])

        const getSearchTags = async (searchText, type) => {
        try {
        const response = await axios.post(tagList, {
            "tag": searchText,
            "includes_secondary_tags": secondaryTagCheck,
            "type"    : type

        }, {
            headers: {
            "Authorization": getToken()
            }
        });

        if (response.status === 200) {
            return response.data;
        } else {
            return [];
        }
        } catch (error) {
            return [];
        }
    }


    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const competitorTags = await getSearchTags("ALL", "competitor")
        const secondaryTags = await getSearchTags("ALL", "secondary")
        // console.log(tags, competitorTags, 'promi')
        openTagModal(tags, competitorTags, secondaryTags)
    };
        
    const  [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);
    const [activeFilterSection, setActiveFilterSection] = useState('keyword');

    // Count functions for filter badges
    const countKeywordFilters = () => {
        const hasTags = TagsOptions?.some(tag => tag.isChecked) ? 1 : 0;
        const hasIncubator = incubatorOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasTargetCompany = TargetCompanyOptions?.some(opt => opt.isChecked) ? 1 : 0;
        
        return hasTags + hasIncubator + hasTargetCompany;
    };

    const countDealFilters = () => {
        const hasYearFounded = (StartYearOptions?.some(option => option.isChecked) || EndYearOptions?.some(option => option.isChecked)) ? 1 : 0;
        const hasIncubationStatus = IncubationStatusOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasExcludeDefunct = isExclude ? 1 : 0;
        const hasVcFunded = VCFundedOptions?.some(opt => opt.isChecked) ? 1 : 0;
        
        return hasYearFounded + hasIncubationStatus + hasExcludeDefunct + hasVcFunded;
    };

    const countCompanyFilters = () => {
        const hasIndustry = IndustriesOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasSector = SectorOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasCountry = CountryOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasRegion = RegionOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasState = StateOptions?.some(opt => opt.isChecked) ? 1 : 0;
        const hasCity = CityOptions?.some(opt => opt.isChecked) ? 1 : 0;
        
        return hasIndustry + hasSector + hasCountry + hasRegion + hasState + hasCity;
    };

    const countInvestorFilters = () => {
        const hasFirmType = FirmTypeOptions?.some(opt => opt.isChecked) ? 1 : 0;
        
        return hasFirmType;
    };

    const openTagModal = (non_comp, comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            comp: comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () =>{
        setShowDefinitionModal(false);
        setDefValues({})
    }
    
    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-4 overflow-visible flex flex-col">
                        <div className="h-full flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 flex-1">
                            {/* Left Sidebar - Filter Categories */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-center md:items-stretch overflow-hidden flex-wrap md:flex-nowrap no-scrollbar">
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {countKeywordFilters() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {countKeywordFilters()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Deal</span>
                                        {countDealFilters() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {countDealFilters()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Company</span>
                                        {countCompanyFilters() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {countCompanyFilters()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>

                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'investor' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'investor' ? null : 'investor')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Investor</span>
                                        {countInvestorFilters() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'investor' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {countInvestorFilters()}
                                            </span> 
                                        )}
                                    </div>
                                    {activeFilterSection === 'investor' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                            </div>

                            {/* Right Content Area - Filter Options */}
                            <div className="col-span-full md:col-span-6 h-full overflow-visible mt-4 md:mt-0 pb-4 md:pb-0 relative">
                                {/* Keyword Search Section*/}
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative flex flex-col overflow-visible`}>
                                    <div className="space-y-4 flex-shrink-0">
                                        <div className="flex items-center gap-4 border border-gray-300 rounded-md p-1 md:gap-0">
                                            <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                                <Tags
                                                    TagsOptions={TagsOptions}
                                                    customPathname={generalPathname}
                                                    setTagsOptions={setTagsOptions} 
                                                    getSearchTags={getSearchTags}
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                />
                                                <Switch
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                    customPathname={generalPathname} 
                                                />
                                            </div>
                                            <div className="md:hidden flex items-center">
                                                <Tooltip title='Tag List'>
                                                    <FaInfoCircle 
                                                        size={16} 
                                                        color="grey" 
                                                        className="cursor-pointer px-[1px]"
                                                        onClick={fetchData}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                                            <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                                            <span>include secondary tags</span>
                                        </div>
                                        <Tooltip title='Tag List'>
                                            <FaInfoCircle 
                                                size={16} 
                                                color="grey" 
                                                className="cursor-pointer hidden md:block absolute md:left-[103%] md:top-0"
                                                onClick={fetchData}
                                            />
                                        </Tooltip>
                                        </div>
                                    <div className="flex-1 mt-4 overflow-visible">
                                        <div className="space-y-4 pb-4">
                                            <Investor 
                                                options={incubatorOptions}
                                                setOptions={setIncubatorOptions}
                                                customPathname={customPathname}
                                                accordionClick={() => accordionClick(32)}
                                                label="Incubator"
                                                open={select === 32}
                                            />
                                            <TargetCompany 
                                                options={TargetCompanyOptions}
                                                setOptions={setTargetCompanyOptions}
                                                customPathname={generalPathname}
                                                accordionClick={() => accordionClick(31)}
                                                label="Company"
                                                open={select === 31}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Deal Section */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                        <IncubationStatusFilter
                                            IncubationStatusOptions={IncubationStatusOptions}
                                            setIncubationStatusOptions={setIncubationStatusOptions}
                                            customPathname={customPathname}
                                            isPopupOpen={openFilterPopup === 'incubationStatus'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'incubationStatus' : null)} />
                                        <ExcludeDefunctFilter
                                            isExclude={isExclude}
                                            setisExclude={setisExclude}
                                            customPathname={customPathname}
                                            isPopupOpen={openFilterPopup === 'excludeDefunct'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'excludeDefunct' : null)} />
                                        <VcFundedFilter
                                            VCFundedOptions={VCFundedOptions}
                                            setVCFundedOptions={setVCFundedOptions}
                                            customPathname={customPathname}
                                            heading="Angel/VC Funded"
                                            isPopupOpen={openFilterPopup === 'vcFunded'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'vcFunded' : null)} />
                                    </div>

                                {/* Company Section */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4 md:grid-cols-2 md:gap-x-6 md:gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                                        <IndustryFilter
                                            IndustriesOptions={IndustriesOptions}
                                            setIndustriesOptions={setIndustriesOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(1)}
                                            open={select === 1}
                                            isPopupOpen={openFilterPopup === 'industry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)} />
                                        <SectorFilter
                                            SectorOptions={SectorOptions}
                                            setSectorOptions={setSectorOptions}
                                            accordionClick={() => accordionClick(2)}
                                            customPathname={generalPathname}
                                            open={select === 2}
                                            isPopupOpen={openFilterPopup === 'sector'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)} />
                                        <YearFoundedFilter
                                            EndYearOptions={EndYearOptions}
                                            customPathname={generalPathname}
                                            setEndYearOptions={setEndYearOptions}
                                            StartYearOptions={StartYearOptions}
                                            setStartYearOptions={setStartYearOptions}
                                            isPopupOpen={openFilterPopup === 'yearFounded'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'yearFounded' : null)} />
                                        <CountryFilter
                                            CountryOptions={CountryOptions}
                                            setCountryOptions={setCountryOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(10)}
                                            onChange={onCountryChange}
                                            open={select === 10}
                                            isPopupOpen={openFilterPopup === 'country'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'country' : null)} />
                                        <RegionFilter
                                            RegionOptions={RegionOptions}
                                            setRegionOptions={setRegionOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(11)}
                                            onChange={onRegionChange}
                                            open={select === 11}
                                            isPopupOpen={openFilterPopup === 'region'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'region' : null)} />
                                        <StateFilter
                                            StateOptions={StateOptions}
                                            setStateOptions={setStateOptions}
                                            customPathname={generalPathname}
                                            onChange={onStateChange}
                                            accordionClick={() => accordionClick(12)}
                                            open={select === 12}
                                            isPopupOpen={openFilterPopup === 'state'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'state' : null)} />
                                        <CityFilter
                                            CityOptions={CityOptions}
                                            setCityOptions={setCityOptions}
                                            customPathname={generalPathname}
                                            accordionClick={() => accordionClick(13)}
                                            open={select === 13}
                                            isPopupOpen={openFilterPopup === 'city'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)} />
                                </div>

                                {/* Investor Section */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-4 md:grid-cols-2 md:gap-4 md:gap-y-8 ${activeFilterSection === 'investor' ? '' : 'hidden'}`}>
                                        <FirmTypeFilter
                                            FirmTypeOptions={FirmTypeOptions}
                                            setFirmTypeOptions={setFirmTypeOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(16)}
                                            dataPath="incubation"
                                            open={select === 16}
                                            isPopupOpen={openFilterPopup === 'firmType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'firmType' : null)} />
                                </div>
                            </div>
                        </div>

                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal 
                    values={defValues} 
                    onClose={defCloseHandler} 
                    TagsOptions={TagsOptions} 
                    setTagsOptions={setTagsOptions}
                    customPathname={generalPathname}
                />}
        </div>
    )
}

export default IncubationRefineSearch